import React from "react"
import PropTypes from "prop-types"
import Checkbox from "../inputs/Checkbox"

function IncludeOption({ checked, onChangedEvent, text }) {
  return <Checkbox labelText={text} checked={checked} onChangeHandler={onChangedEvent} />
}

IncludeOption.propTypes = {
  text: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  onChangedEvent: PropTypes.func.isRequired
}

export default IncludeOption



// WEBPACK FOOTER //
// ./src/components/custom-report/IncludeOption.jsx